<template>
	<div class="home-overlay">

		<div class="row my-lg-5">
			<div class="col-10 offset-1 my-lg-5">
				<div class="header">
					<h1 class="mt-5">build your</h1>
					<h1>Own <span class="green">Oasis</span></h1>
					<h2 class="text-uppercase">We build virtual worlds</h2>
				</div>

				<p class="my-5 col-lg-4 col-md-9 info">Our drag & drop Metaverse creator makes it easy for anyone to build their
					Metaverse vision without any coding experience. Users can create interactive & immersive experiences along
					with building rich web3 enabled interactions.</p>

				<div class="row">
					<div class="col-md-3 col-sm-6">
						<a class="btn btn-primary btn-block" href="#buy">Buy Now</a>
					</div>
					<div class="col-md-3 col-sm-6 pt-3 pt-md-0 text-center">
						<a class="btn btn-primary video-text pe-3" :href="trailerSrc" target="_blank">Watch the video <i
								class="fa fa-play-circle"></i></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "HomeOverlay",
	data() {
		return {
			trailerSrc: "https://www.youtube.com/watch?v=f-fCQJcDCJE",
		}
	}
}
</script>

<style scoped>


a {
	text-decoration: none;
	color: white;
	text-transform: uppercase;
}

.video-text {
	line-height: 2.5em;
	background: rgba(0, 0, 0, 0.5);
	padding-left: 25px;
	padding-right: 25px !important;
}

.video-text:hover {
	background: rgba(0, 0, 0, 0.8);
}

.fa-play-circle {
	padding-left: 25px;
}

.header {
	border-left: 5px solid #46CE7C;
	padding-left: 3%;
}

.info {

}

h1 {
	font-size: 5em;
	text-transform: uppercase;
	margin-bottom: 0;
	line-height: 1;
}

h2 {
	color: white;
	font-weight: normal;
	margin-bottom: 0;
}

</style>